import illustratorIcon from './assets/illustrator.svg';
import reactIcon from './assets/react.svg';
import reduxIcon from './assets/redux.svg';
import reactRouterIcon from './assets/react-router.svg';
import graphqlIcon from './assets/graphql.svg';
import gatsbyIcon from './assets/gatsby.svg';
import styledComponentsIcon from './assets/styled-components.png';
import sketchIcon from './assets/sketch.svg';
import invisionIcon from './assets/invision.svg';
import googleSheetsIcon from './assets/google-sheets.png';
import swiftIcon from './assets/swift.svg';
import xcodeIcon from './assets/xcode.png';
import firebaseIcon from './assets/firebase.svg';
import nextIcon from './assets/next.svg';
import flutterIcon from './assets/flutter.svg';
import dartIcon from './assets/dart.svg';
import sqliteIcon from './assets/sqlite.svg';
import typescriptIcon from './assets/typescript.svg';
import jestIcon from './assets/jest.svg';
import reactTestingLibIcon from './assets/react-testing-lib.png';
import apolloIcon from './assets/apollo.svg';
import cypressIcon from './assets/cypress.svg';
import tailwindIcon from './assets/tailwind-css.svg';
import twinMacroIcon from './assets/twin-macro.png';
import dayjsIcon from './assets/day-js.png';
import githubIcon from './assets/github.png';
import youtubeIcon from './assets/youtube.png';
import googleIcon from './assets/google.png';
import smuiIcon from './assets/smui.png';
import svelteIcon from './assets/svelte.png';

const Skills = {
  twinMacro: {
    name: 'Twin Macro',
    image: twinMacroIcon,
  },
  tailwind: {
    name: 'TailwindCSS',
    image: tailwindIcon,
  },
  cypress: {
    name: 'Cypress',
    image: cypressIcon,
  },
  apollo: {
    name: 'Apollo Client',
    image: apolloIcon,
  },
  illustrator: {
    name: 'Adobe Illustrator',
    image: illustratorIcon,
  },
  react: {
    name: 'React',
    image: reactIcon,
  },
  redux: {
    name: 'Redux',
    image: reduxIcon,
  },
  reactrouter: {
    name: 'React Router',
    image: reactRouterIcon,
  },
  graphql: {
    name: 'GraphQL',
    image: graphqlIcon,
  },
  gatsby: {
    name: 'Gatsby',
    image: gatsbyIcon,
  },
  styledcomponents: {
    name: 'Styled Components',
    image: styledComponentsIcon,
  },
  sketch: {
    name: 'Sketch',
    image: sketchIcon,
  },
  invision: {
    name: 'Invision',
    image: invisionIcon,
  },
  googlesheets: {
    name: 'Google Sheets',
    image: googleSheetsIcon,
  },
  swift: {
    name: 'Swift',
    image: swiftIcon,
  },
  xcode: {
    name: 'XCode',
    image: xcodeIcon,
  },
  firebase: {
    name: 'Firebase',
    image: firebaseIcon,
  },
  next: {
    name: 'Next',
    image: nextIcon,
  },
  flutter: {
    name: 'Flutter',
    image: flutterIcon,
  },
  dartprovider: {
    name: 'Provider',
    image: dartIcon,
  },
  sqlite: {
    name: 'SQLite',
    image: sqliteIcon,
  },
  typescript: {
    name: 'TypeScript',
    image: typescriptIcon,
  },
  jest: {
    name: 'Jest',
    image: jestIcon,
  },
  reactTestingLib: {
    name: 'React Testing Library',
    image: reactTestingLibIcon,
  },
  dayjs: {
    name: 'Day.js',
    image: dayjsIcon,
  },
  githubPages: {
    name: 'GitHub Pages',
    image: githubIcon,
  },
  youtubeApi: {
    name: 'YouTube API',
    image: youtubeIcon,
  },
  googleAuth: {
    name: 'GoogleAuth',
    image: googleIcon,
  },
  smui: {
    name: 'Svelte MaterialUI',
    image: smuiIcon,
  },
  svelte: {
    name: 'Svelte',
    image: svelteIcon,
  },
};

export default Skills;
